/*
 * Checks of what a buyer types, shared by the API and the Mini App (moved from the
 * sales bot's aitole.ts and lava.ts, which took a live Kaspi payment on 2026-10-11).
 */

/**
 * A Kazakh mobile number in E.164: '8 707 123 45 67', '+7 (707) 123-45-67' and
 * '7071234567' all give '+77071234567'. A Russian '+7 9…' number gives undefined.
 */
export function normalizeKzPhone(input: string): string | undefined {
  let d = input.replace(/\D/g, '');
  if (d.length === 11 && (d.startsWith('8') || d.startsWith('7'))) d = d.slice(1);
  if (d.length !== 10 || !d.startsWith('7')) return undefined;
  return `+7${d}`;
}

/** '+7 7** *** **67': the only form of the number the server keeps. */
export const maskPhone = (e164: string): string => `+7 ${e164.slice(2, 3)}** *** **${e164.slice(-2)}`;

/** A plain x@y.zz address of at most 254 characters, spaces around ignored. */
export const isEmail = (s: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s.trim()) && s.trim().length <= 254;

const NBSP = '\u00a0';
const NNBSP = '\u202f';

/** 7490 → «7 490» with a narrow no-break space, like Russian money is printed. */
const groupDigits = (amount: number) => String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, NNBSP);

const CURRENCY_SIGNS: Record<'KZT' | 'RUB' | 'XTR', string> = { KZT: '₸', RUB: '₽', XTR: '⭐' };

/** «7 490 ₸», «1 490 ₽», «$17», «1 300 ⭐»: the same in the bot's messages and in the Mini App. */
export function formatAmount(amount: number, currency: 'KZT' | 'RUB' | 'USD' | 'XTR'): string {
  if (currency === 'USD') return `$${groupDigits(amount)}`;
  return `${groupDigits(amount)}${NBSP}${CURRENCY_SIGNS[currency]}`;
}
